/**
 * Presença do tablet pelo último sinal do WebSocket (`adm-backend`, `db/conexao.py`): Online até
 * 15 s sem sinal, Instável até 45 s (queda curta, o tablet está reconectando), Offline depois.
 */
export type Conexao = 'online' | 'instavel' | 'offline';

const ROTULO: Record<Conexao, string> = { online: 'Online', instavel: 'Instável', offline: 'Offline' };

const DICA: Record<Conexao, string> = {
    online: 'Tablet conectado agora.',
    instavel: 'Queda curta de sinal: o tablet está tentando reconectar.',
    offline: 'Tablet sem sinal há mais de 45 segundos, ou sem login.',
};

export function SeloDeConexao({ conexao }: { conexao: Conexao | undefined }) {
    const estado = conexao ?? 'offline';
    return <span className={`conexao-${estado}`} title={DICA[estado]}>{ROTULO[estado]}</span>;
}
